import styled from 'react-emotion';

import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 72px;
`;

export const NoGroupsIcon = styled('img')`
  width: 180px;
  height: 180px;
  border-radius: 50%;
`;

export const Title = styled('div')`
  padding-top: 16px;
  font-size: 16px;
  font-weight: 600;
  color: ${colors.purple};
`;

export const Text = styled('div')`
  padding-top: 8px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #31405c;
  &:focus {
    outline: none;
  }
`;
